import { PlusIcon } from 'lucide-react';

import type { FlatGraphNode } from '@/sections/insights/queryBuilder/types/FlatGraph';
import type { QueryFilter } from '@/types';

interface NodeFiltersActionsProps {
  node: FlatGraphNode;
  filters: QueryFilter[];
  editable: boolean;
  firstLabel: string;
  onUpdateFilters?: (nodeId: string, filters: QueryFilter[]) => void;
  handleAddFilter: (currentFilters: QueryFilter[]) => QueryFilter[];
}

/**
 * NodeFiltersActions - Renders "Add Filter" button
 * Only visible in editable mode with onUpdateFilters callback
 */
export const NodeFiltersActions = ({
  node,
  filters,
  editable,
  firstLabel,
  onUpdateFilters,
  handleAddFilter,
}: NodeFiltersActionsProps) => {
  if (!editable || !onUpdateFilters) {
    return null;
  }

  return (
    <button
      onClick={() => {
        const updatedFilters = handleAddFilter(filters);
        onUpdateFilters(node.id, updatedFilters);
      }}
      className="border-chariot-stroke text-chariot-brand-primary hover:bg-chariot-background-secondary mt-2 flex w-full items-center justify-center gap-2 rounded border py-1.5 text-xs font-medium transition-colors"
      data-testid={`add-filter-${node.id}`}
      aria-label={`Add filter to ${firstLabel} node`}
    >
      <PlusIcon className="h-3 w-3" />
      <span>Add Filter</span>
    </button>
  );
};
